import { Injectable, OnDestroy } from '@angular/core';
import { FeatureDecisionService } from '../feature-decision/feature-decision.service';

@Injectable({ providedIn: 'root' })
export class FeatureInjector implements OnDestroy {
  public static featureDecisionService: FeatureDecisionService;

  constructor(featureDecisionService: FeatureDecisionService) {
    FeatureInjector.featureDecisionService = featureDecisionService;
  }

  ngOnDestroy(): void {
    FeatureInjector.featureDecisionService = null;
  }
}
